/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import useOrganizationId from '@modules/billing-lib/hooks/useOrganizationId'
import useGetBillingHistory, {
  type BillingHistory,
} from '@modules/billing-lib/queries/useGetBillingHistory'

const useBillingHistory = (): {
  billingHistory?: BillingHistory
  isLoading: boolean
  error: unknown | null
} => {
  const organizationId = useOrganizationId()

  const {
    data: billingHistory,
    isLoading: isLoadingBillingHistory,
    error: billingHistoryError,
  } = useGetBillingHistory(organizationId)

  return {
    // TODO: remove this cast once the API is fixed to return correct billing history types
    billingHistory: billingHistory as BillingHistory,
    isLoading: isLoadingBillingHistory,
    error: billingHistoryError,
  }
}

export default useBillingHistory
